import { useCallback, useEffect, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import { v4 as uuidv4 } from 'uuid';
import { CREATE_FORM, GET_FORM, UPDATE_FORM } from './gql';

export default function useFormFee(formId, initState = {}) {
  const [form, setForm] = useState({
    slug: '',
    countryId: null,
    collectionId: null,
    organizationId: null,
    researcherName: '',
    clientType: '',
    transferDirection: '',
    ...initState,
  });
  const [fetchForm, { loading, error }] = useLazyQuery(GET_FORM, {
    onCompleted: (data) =>
      setForm({
        ...data.form,
      }),
  });
  const [createForm] = useMutation(CREATE_FORM, {
    onError: () => undefined,
  });
  const [updateForm] = useMutation(UPDATE_FORM, {
    onError: () => undefined,
  });

  const saveForm = useCallback(
    (options) => {
      const isNew = !isFinite(form.id);
      return isNew ? createForm(options) : updateForm(options);
    },
    [form.id, createForm, updateForm],
  );

  const changeSlug = useCallback(() => {
    setForm((prev) => ({ ...prev, slug: uuidv4() }));
  }, []);

  useEffect(() => {
    if (isFinite(formId)) {
      fetchForm({ variables: { formId: parseInt(formId) } });
    } else {
      // generate slug for new form
      changeSlug();
    }
  }, [formId, fetchForm, changeSlug]);

  return {
    form,
    loading,
    error,
    setForm,
    createForm,
    updateForm,
    saveForm,
    changeSlug,
  };
}
